<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>

  <div class="container-fluid">
    <div class="card">
      <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
        <h4 class="card-title mb-0">Bill Categories</h4>
        <div class="d-flex align-items-center gap-3">
          <select class="form-select form-select-sm" style="min-width:180px" (change)="onBillTypeFilter($event)">
            <option value="">All Types</option>
            <option *ngFor="let t of billTypes" [value]="t.key">{{ t.label }}</option>
          </select>
          <button class="btn btn-primary btn-sm" (click)="openCreateModal()">
            + Add Category
          </button>
        </div>
      </div>

      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table mb-0 table-hover">
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Bill Type</th>
                <th class="text-center">Enable Notification</th>
                <th class="text-center">Notify Owner</th>
                <th class="text-center">Notify Tenant</th>
                <th class="text-end pe-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="isLoading">
                <td colspan="7" class="text-center py-4">Loading...</td>
              </tr>
              <tr *ngIf="!isLoading && filteredCategories.length === 0">
                <td colspan="7" class="text-center py-4 text-muted">No categories found.</td>
              </tr>
              <tr *ngFor="let cat of filteredCategories; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ cat.name }}</td>
                <td>
                  <span class="badge badge-sm badge-primary">{{ getBillTypeLabel(cat.bill_type) }}</span>
                </td>
                <td class="text-center">
                  <span class="badge badge-sm" [ngClass]="cat.enable_notification ? 'badge-success' : 'badge-light'">
                    {{ cat.enable_notification ? 'Yes' : 'No' }}
                  </span>
                </td>
                <td class="text-center">
                  <span *ngIf="cat.enable_notification" class="badge badge-sm"
                    [ngClass]="cat.owner_notification ? 'badge-success' : 'badge-danger'">
                    {{ cat.owner_notification ? 'Yes' : 'No' }}
                  </span>
                  <span *ngIf="!cat.enable_notification" class="text-muted">—</span>
                </td>
                <td class="text-center">
                  <span *ngIf="cat.enable_notification" class="badge badge-sm"
                    [ngClass]="cat.tenant_notification ? 'badge-success' : 'badge-danger'">
                    {{ cat.tenant_notification ? 'Yes' : 'No' }}
                  </span>
                  <span *ngIf="!cat.enable_notification" class="text-muted">—</span>
                </td>
                <td class="text-end pe-4">
                  <button class="btn btn-xs btn-outline-primary me-2" (click)="openEditModal(cat)">Edit</button>
                  <button class="btn btn-xs btn-outline-danger" (click)="deleteCategory(cat)">Delete</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create / Edit Modal -->
<div class="modal fade show d-block" tabindex="-1" role="dialog" *ngIf="showModal"
  style="background:rgba(0,0,0,0.5)">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ isEditMode ? 'Edit Category' : 'Add Category' }}</h5>
        <button type="button" class="btn-close" (click)="closeModal()"></button>
      </div>

      <div class="modal-body">
        <form [formGroup]="categoryForm" autocomplete="off">
          <!-- Bill Type -->
          <div class="mb-3">
            <label class="form-label">Bill Type <span class="text-danger">*</span></label>
            <select class="form-select" formControlName="bill_type"
              [ngClass]="{'is-invalid': categoryForm.get('bill_type')?.invalid && categoryForm.get('bill_type')?.touched}">
              <option [ngValue]="null" disabled>Select type</option>
              <option *ngFor="let t of billTypes" [value]="t.key">{{ t.label }}</option>
            </select>
            <div class="invalid-feedback">Bill type is required.</div>
          </div>

          <!-- Name -->
          <div class="mb-3">
            <label class="form-label">Category Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="name" placeholder="e.g. Maintenance"
              [ngClass]="{'is-invalid': categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched}" />
            <div class="invalid-feedback">Name is required (2–40 characters).</div>
          </div>

          <hr class="my-3" />
          <p class="text-muted small mb-3">
            <strong>Enable Notification</strong> is the master switch — emails are sent only when this is on,
            regardless of whether the bill is taxable or non-taxable.
            <strong>Notify Owner</strong> and <strong>Notify Tenant</strong> control who receives the email.
          </p>

          <!-- Enable Notification -->
          <div class="mb-3 d-flex align-items-center justify-content-between">
            <label class="form-label mb-0">Enable Notification</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" formControlName="enable_notification" />
            </div>
          </div>

          <!-- Owner Notification (disabled when enable_notification is off) -->
          <div class="mb-3 d-flex align-items-center justify-content-between"
            [ngClass]="{'opacity-50': !isNotificationEnabled()}">
            <label class="form-label mb-0">Notify Owner</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" formControlName="owner_notification"
                [attr.disabled]="!isNotificationEnabled() ? true : null" />
            </div>
          </div>

          <!-- Tenant Notification (disabled when enable_notification is off) -->
          <div class="mb-3 d-flex align-items-center justify-content-between"
            [ngClass]="{'opacity-50': !isNotificationEnabled()}">
            <label class="form-label mb-0">Notify Tenant</label>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" formControlName="tenant_notification"
                [attr.disabled]="!isNotificationEnabled() ? true : null" />
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveCategory()">
          {{ isEditMode ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</div>
